"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightClassB = exports.FlightClassC = exports.FlightClassP = exports.FlightClassY = exports.FlightDirectionOpenJaw = exports.FlightDirectionRoundTrip = exports.FlightDirectionReturning = exports.FlightDirectionOutgoing = void 0;
exports.FlightDirectionOutgoing = 'O';
exports.FlightDirectionReturning = 'R';
exports.FlightDirectionRoundTrip = 'RT';
exports.FlightDirectionOpenJaw = 'OJ';
exports.FlightClassY = 'Y';
exports.FlightClassP = 'P';
exports.FlightClassC = 'C';
exports.FlightClassB = 'B';
//# sourceMappingURL=flight.js.map